import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  createRVMTemplateCategory,
  fetchRVMTemplateCategories
} from "../actions/index";
import RVMTemplatesCategoryForm from "./RVMTemplatesCategoryForm";
import { toastr } from "react-redux-toastr";

class RVMTemplatesCategoryNewInline extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    createRVMTemplateCategory: PropTypes.func.isRequired,
    handleUpdateRVMTemplateCategoryId: PropTypes.func.isRequired,
    fetchRVMTemplateCategories: PropTypes.func.isRequired
  };

  onSubmit(state) {
    this.props
      .createRVMTemplateCategory(state)
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("Category created!");
          this.props
            .fetchRVMTemplateCategories(
              "?per_page=1000"
            )
            .then(categories => {
              this.props.handleUpdateRVMTemplateCategoryId(
                response.payload.data.data,
                categories.payload.data.data
              );
            });
        }
      });
  }

  render() {
    return (
      <div>
        <RVMTemplatesCategoryForm
          handleSubmit={this.onSubmit.bind(this)}
          mode="new"
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { createRVMTemplateCategory, fetchRVMTemplateCategories }
)(RVMTemplatesCategoryNewInline);
